/*
 * Copyright (c) 2025. Orion Analytics. All Rights Reserved
 */

import React, {useContext, useEffect, useState} from "react";


import VaRVisualizerDetailed from "./varVisualizerDetailed";

const VARPage = () => {

  const subSections = ["VaR"];
  const [activeSubTab, setActiveSubTab] = useState(subSections[0]);

  const renderContent = () => {

    switch (activeSubTab) {
        case "VaR":
        return  (<div align={"center"}>
      <VaRVisualizerDetailed/>
            </div>)
      default:
        return <div>Select a tab to view content.</div>;
    }
  };

  return (
    <div className="section-container">
      {/* Vertical Sidebar */}
      <div className="sidebar">
        {subSections.map((tab) => (
          <button
            key={tab}
            className={`side-tab ${activeSubTab === tab ? "active" : ""}`}
            onClick={() => setActiveSubTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Content Display */}
      <div className="content">
        {/*<h2>{activeSubTab}</h2>*/}
        {/*<p>Displaying data for {activeSubTab}...</p>*/}
        {renderContent()}
      </div>
    </div>
  );
};

export default VARPage;

// ✅ CSS-in-JS (Replacing Tailwind)
const styles = {
  container: {
    display: "flex",
    padding: "16px",
  },
  chartContainer: {
    width: "93%",
    paddingRight: "16px",
  },
  sidebar: {
    width: "7%",
    padding: "16px",
    borderLeft: "1px solid #ccc",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
  },
  title: {
    fontSize: "1.25rem",
    fontWeight: "bold",
  },
  timeframeContainer: {
    display: "flex",
    gap: "12px",
  },
  timeframeOption: {
    cursor: "pointer",
    color: "#555",
  },
  sidebarTitle: {
    fontSize: "1rem",
    fontWeight: "bold",
    marginBottom: "8px",
  },
  tickerList: {
    listStyleType: "none",
    padding: 0,
    margin: 0,
  },
  tickerItem: {
    cursor: "pointer",
    color: "#555",
    padding: "4px 0",
    borderBottom: "1px dashed #ccc",
    transition: "color 0.2s",
  },
};